import { action, computed, observable } from 'mobx';
import { Content } from './modules/content';
import { Independent } from './modules/independent';
import { Catalog } from './modules/catalog';
import { Layout } from './modules/layout';
import { Auth } from './modules/auth';
import { Course } from './modules/course';
import { Guide } from './modules/guide';
import { Preparation } from './modules/preparation';
import { Album } from 'common/v2store/modules/album';
import { Library } from 'common/v2store/modules/library';
import { Cart } from 'common/v2store/modules/cart';
import { TipsCart } from 'common/v2store/modules/tips-cart';

const KEY_MAP = { uuid: 'value', name: 'label' };

export default class {
  private urlEventRes;

  // modules
  public content;
  public independent;
  public catalog;
  public layout;
  public auth;
  public course;
  public guide;
  public preparation;
  public album;
  public library;
  public cart;
  public tipsCart;

  @observable public timestamp = Date.now();
  @observable public params = nx.hashlize();

  @computed get isExternal() {
    return alo7Account.platform === 'external';
  }

  @computed get isInternal() {
    return alo7Account.platform === 'internal';
  }

  @computed get isInternalUser() {
    return alo7Account.userType === 'LDAP_USER';
  }

  @computed get isExternalUser() {
    return alo7Account.userType === 'TPUSER';
  }

  @computed get isEmptyExtSchoolId() {
    const { schoolId, platform } = nx.hashlize();
    return !schoolId && platform === 'external';
  }

  @computed get isAiCourseWare() {
    const { bizType, schema } = this.params;
    if (!schema) return false;
    return bizType === 'courseWare' && schema.includes('AI_');
  }

  @computed get albumTypes() {
    const { modules } = alo7Account;
    const items = modules.find(item => item.uuid === 'ALBUM').subModules;
    return nx.keyMap(items, KEY_MAP);
  }

  @action
  public forceUpdate = () => {
    this.timestamp = Date.now();
  };

  constructor() {
    this.content = new Content(this);
    this.independent = new Independent(this);
    this.catalog = new Catalog(this);
    this.layout = new Layout(this);
    this.auth = new Auth(this);
    this.course = new Course(this);
    this.guide = new Guide(this);
    this.album = new Album(this);
    this.library = new Library(this);
    this.preparation = new Preparation(this);
    this.cart = new Cart(this);
    this.tipsCart = new TipsCart(this);
    this.urlEventRes = nx.$event.on('url.change', () => {
      this.params = nx.hashlize();
    });
  }
}
